import { TGetUserSettingOutputDto } from "@/api/services/main/user-setting/dtos/get-user-setting.dto";
import { TUpdateUserSettingReqDto } from "@/api/services/main/user-setting/dtos/update-user-setting.dto";
import { TUserSettingForm } from "@/features/user-setting/types/UserSettingForm";

const intiForm = {
  userFullName: null,
  emailDeliveryOptions: [],
};

export const getInitValues = () => {
  return {
    ...intiForm,
  };
};

export const convertFormDataToReqDto = (data: TUserSettingForm): TUpdateUserSettingReqDto => {
  return {
    ...intiForm,
    userFullName: data.userFullName ?? undefined,
    emailDeliveryOptions: data.emailDeliveryOptions ?? undefined,
    userDepartment: data.userDepartment ?? "",
    userPosition: data.userPosition ?? "",
  };
};

export const convertResDtoToFormData = (data: TGetUserSettingOutputDto): TUserSettingForm => {
  return {
    ...data,
    userFullName: data.userFullName ?? undefined,
    userNewEmail: data.userNewEmail ?? undefined,
    emailDeliveryOptions: data.emailDeliveryOptions ?? undefined,
    userDepartment: data.userDepartment ?? undefined,
    userPosition: data.userPosition ?? undefined,
  };
};
